import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import { hotKeywords, siteInfo } from "@/mocks/site";
import { hotTopics } from "@/mocks/hotTopics";

export default function HeroSection() {
  const marqueeItems = [...hotTopics, ...hotTopics];

  return (
    <section className="relative flex min-h-[620px] w-full items-center overflow-hidden md:min-h-[720px]">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20entertainment%20stage%20scene%20with%20two%20glowing%20spotlights%20facing%20each%20other%20across%20a%20dark%20crimson%20floor%2C%20scattered%20golden%20bokeh%20particles%20floating%20in%20dramatic%20warm%20rim%20light%2C%20deep%20shadow%20negative%20space%20in%20the%20center%20for%20text%20overlay%2C%20luxury%20magazine%20cover%20aesthetic%2C%20cinematic%20atmosphere%2C%20no%20people&width=1600&height=1000&seq=kawei-hero-01&orientation=landscape"
        alt="网红明星跨界对比同框观察首屏背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/80" />

      <Container className="relative z-10 w-full py-28 md:py-32">
        <div className="max-w-3xl animate-rise">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium tracking-wide text-accent-300 backdrop-blur-sm">
            <i className="ri-fire-line text-sm" />
            {siteInfo.tagline} · 每周更新跨界对比
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.2] text-background-50 md:text-5xl lg:text-[3.4rem]">
            网红明星同框，
            <br className="hidden sm:block" />
            差距到底有多大
          </h1>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            我们把「谁更火」拆成热度、话题、商业、专业四个维度，从直播间同框到红毯站位，帮你看懂位置关系与流量变迁。不拉踩、不站队，只讲可复核的门道。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/compare"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-scales-3-line text-base" />
              </span>
              查看对比榜单
            </Link>
            <Link
              to="/articles"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-article-line text-base" />
              </span>
              阅读深度解读
            </Link>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {hotKeywords.slice(0, 5).map((word) => (
              <span
                key={word}
                className="rounded-full border border-background-50/20 px-3 py-1 text-xs text-background-100/85"
              >
                {word}
              </span>
            ))}
          </div>
        </div>
      </Container>

      <div className="absolute inset-x-0 bottom-0 z-10 border-t border-background-50/15 bg-foreground-950/45 backdrop-blur-sm">
        <div className="flex items-center gap-4 overflow-hidden py-3">
          <span className="ml-4 hidden shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-secondary-950 md:inline-flex">
            <i className="ri-flashlight-fill text-sm" />
            实时热点
          </span>
          <div className="overflow-hidden">
            <div className="marquee-track flex w-max gap-6">
              {marqueeItems.map((topic, index) => (
                <span
                  key={`${topic.id}-${index}`}
                  className="flex items-center gap-2 whitespace-nowrap text-xs text-background-100/85"
                >
                  <span className="flex h-4 w-4 items-center justify-center text-accent-400">
                    <i className="ri-fire-line text-sm" />
                  </span>
                  {topic.title}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}